export const skipKeyCodes = [46, 8, 37, 39, 9];
export const deleteKeyCodes = [46, 8];
